// This component's implementation is copied from existing `EditChannelPanel` component

import EditScheduledEventPanel from './EditScheduledEventPanel';

export default EditScheduledEventPanel;
